export const categoriesEntityName = 'Categories'
export interface CategoriesEntity {
  uuid: string
  auction: string
  label: string
  label_slug: string
  items: string[]
  order: number
}

export const CATEGORIES_LOADER = {
  reOrderCategories: {
    id: 'reOrderCategories',
    message: 'LOADER.REORDERING_CATEGORIES',
  },
  deleteCategory: {
    id: 'deleteCategory',
    message: 'LOADER.DELETING_CATEGORY',
  },
}
